"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MFContext = exports.MFProvider = void 0;
/* eslint-disable no-underscore-dangle */
var react_1 = __importStar(require("react"));
var MessageBusService_1 = __importDefault(require("../../shared/src/services/MessageBusService"));
var TokenService_1 = __importDefault(require("../../shared/src/services/TokenService"));
var MFContext = react_1.default.createContext({});
exports.MFContext = MFContext;
function Loading() {
    return react_1.default.createElement("div", null, "Loading...");
}
var MFProvider = function (_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)(null), mf = _b[0], setMf = _b[1];
    function load(mfs, sharedDependencies, authorization, history) {
        (0, react_1.useEffect)(function () {
            function loadMf() {
                var _a;
                return __awaiter(this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_b) {
                        window.__mf = __assign(__assign({ apps: {}, shared: {}, configs: {} }, window.__mf), { services: __assign({ TokenService: new TokenService_1.default(authorization), MessageBusService: new MessageBusService_1.default() }, (_a = window.__mf) === null || _a === void 0 ? void 0 : _a.services), history: history !== undefined || window.__mf === undefined
                                ? history
                                : window.__mf.history });
                        sharedDependencies === null || sharedDependencies === void 0 ? void 0 : sharedDependencies.forEach(function (_a) {
                            var name = _a.name, value = _a.value;
                            window[name] = value;
                        });
                        mfs.forEach(function (_a) {
                            var config = _a.config, js = _a.js, name = _a.name, css = _a.css, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
                            return __awaiter(_this, void 0, void 0, function () {
                                var res, configJson_1, scriptTag, stylesTag, e_1;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            if (!enabled) return [3 /*break*/, 5];
                                            _c.label = 1;
                                        case 1:
                                            _c.trys.push([1, 4, , 5]);
                                            return [4 /*yield*/, fetch(config)];
                                        case 2:
                                            res = _c.sent();
                                            return [4 /*yield*/, res.json()];
                                        case 3:
                                            configJson_1 = _c.sent();
                                            window.__mf.configs[name] = configJson_1;
                                            scriptTag = document.createElement('script');
                                            scriptTag.src = configJson_1.BUILD_NUMBER
                                                ? "".concat(js, "?b=").concat(configJson_1.BUILD_NUMBER)
                                                : js;
                                            scriptTag.onload = function () {
                                                var _a, _b;
                                                (_b = (_a = window.__mf.component).init) === null || _b === void 0 ? void 0 : _b.call(_a, configJson_1);
                                                // eslint-disable-next-line
                                                var StaticComp = window.__mf.component.reactElement ||
                                                    window.__mf.component.default;
                                                setMf(function (prevState) {
                                                    var _a;
                                                    return (__assign(__assign({}, (prevState !== null && prevState !== void 0 ? prevState : {})), (_a = {}, _a[name] = function (props) { return (react_1.default.createElement(StaticComp, __assign({}, props, { env: { config: configJson_1 } }))); }, _a)));
                                                });
                                                window.__mf.component = undefined;
                                            };
                                            stylesTag = document.createElement('link');
                                            stylesTag.rel = 'stylesheet';
                                            stylesTag.href = configJson_1.BUILD_NUMBER ? "".concat(css, "?b=").concat(configJson_1.BUILD_NUMBER) : css;
                                            document.head.appendChild(stylesTag);
                                            document.head.appendChild(scriptTag);
                                            return [3 /*break*/, 5];
                                        case 4:
                                            e_1 = _c.sent();
                                            console.log("Error occurred while loading ".concat(name, "."));
                                            return [3 /*break*/, 5];
                                        case 5: return [2 /*return*/];
                                    }
                                });
                            });
                        });
                        return [2 /*return*/];
                    });
                });
            }
            loadMf();
        }, []);
        return [mf || Loading];
    }
    var value = (0, react_1.useMemo)(function () { return (__assign({ load: load }, mf)); }, [load, mf]);
    return react_1.default.createElement(MFContext.Provider, { value: value }, children);
};
exports.MFProvider = MFProvider;
